module.exports = __webpack_public_path__ + "img/error-dark.d581cfc7.svg";